import React from 'react';
import './Dropdown.scss';

interface Props {
  label: string;
  values: {
    id: string | number;
    title: string;
    shortForm: string;
  }[];
  handleField: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  disabled?: boolean;
}

function Dropdown({
  label, values, handleField, disabled,
}: Props) {
  return (
    <>
      {/* <div className={`dropdown${isVertical ? " vert" : ""}`}> */}
      <div className="form_wrapper">
        <label>{label}</label>
        <br />
        <select name="region" onChange={(e) => handleField(e)} disabled={disabled} defaultValue="">
          <option value="" disabled hidden>
            Select an option
          </option>
          {values.map((value) => (
            <option key={value.id} value={value.id}>
              {value.shortForm}
              {' '}
              -
              {value.title}
            </option>
          ))}
        </select>
      </div>
      {/* </div> */}
    </>
  );
}

export default Dropdown;
